import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import Navbar from '../components/Navbar'

type Props = {
  children: React.ReactNode
}

const MainLayout: React.FC<Props> = ({ children }) => {
  const navigate = useNavigate()

  useEffect(() => {
    // Check for token in local storage
    const authData = localStorage.getItem('auth')
    const token = authData ? JSON.parse(authData).token : null

    if (!token) {
      // If no token, redirect to login page with a toast message
      toast.error('Session expired.')
      navigate('/login')
    }
  }, [navigate])

  return (
    <div>
      <Navbar/>
      {children}
    </div>
  )
}

export default MainLayout
